/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

export const UPDATE_ACTIVE_HASH = 'UPDATE_ACTIVE_HASH';
